// extracted by mini-css-extract-plugin
export default {"preview":"QhpV8ZqP"};